module.exports = __webpack_public_path__ + "static/img/10018.90efe9ee.png";